import { render } from "./Mandrill.vue?vue&type=template&id=310934a6"
import script from "./Mandrill.vue?vue&type=script&lang=js"
export * from "./Mandrill.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__